<template>
  <div style="display: flex;">
    <ButtonPrimary
      class="small create-btn"
      @click.native="$emit('create-new')"
    >
      <template v-slot:icon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21">
          <path d="M10 4.75a.75.75 0 0 0-.75.75v4.25H5a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h4.25v4.25a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-4.25H15a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-4.25V5.5a.75.75 0 0 0-.75-.75z"/>
        </svg>
      </template>
      <div class="add-desktop">Create</div>
    </ButtonPrimary>
    <div class="download-block">
      <ButtonIcon
        class="primary small drop-btn download-block__button"
        @click.native="isShowCreateMenu = !isShowCreateMenu"
      >
        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20">
          <path d="M10 12.4c-.2 0-.4-.1-.5-.2L6.1 8.9c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l2.8 2.8 2.8-2.8c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-3.3 3.3c-.2.1-.4.2-.6.2z"/>
        </svg>
      </ButtonIcon>
      <div
        v-if="isShowCreateMenu"
        class="download-block__items"
        v-click-outside="() => isShowCreateMenu = false"
      >
        <div class="download-block__items__item" @click="$emit('create-color')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
            <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m9.05814 16.8711 3.31456-12.37c.0693-.25889-.0843-.525-.3432-.59437L6.76901 2.49719c-.25889-.06937-.52499.08426-.59436.34315L2.86012 15.2103c-.45861 1.7116.55709 3.4708 2.26863 3.9294 1.71154.4586 3.47079-.5571 3.92939-2.2686Z"/>
            <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.95898 19.2499H18.7654c.268 0 .4853-.2173.4853-.4853v-5.4461M5.95898 16.1334h.002v.002h-.002v-.002Z"/>
            <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.31445 18.9486 18.921 13.5364c.2429-.1133.348-.402.2347-.6449l-2.3016-4.93583c-.1133-.24291-.402-.348-.6449-.23473l-5.1823 2.41656"/>
          </svg>
          Color palette
        </div>
        <div class="download-block__items__item" @click="$emit('create-print')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
            <path stroke="#09373D" stroke-linecap="round" stroke-width="1.5" d="M5.5 4.58331V17.875M11 4.58331V17.875m5.5-13.29169V17.875m1.1465-12.14581H4.35482M17.6465 11.2292H4.35482m13.29168 5.5H4.35482"/>
          </svg>
          Print library
        </div>
        <div class="download-block__items__item" @click="$emit('create-texture')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
            <path stroke="#09373D" stroke-linecap="round" stroke-width="1.5" d="M17.5332 4.69928 4.69987 17.5326M17.416 10.0834l-7.3333 7.3334m-5.49872-5.5001 7.33332-7.33335M17.416 15.5833l-1.8333 1.8333M4.58398 6.41681l1.83334-1.83333"/>
          </svg>
          Texture library
        </div>
        <div class="download-block__items__item" @click="$emit('create-placement-print')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
            <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.416 3.66669H4.58268c-.50626 0-.91666.4104-.91666.91666V17.4167c0 .5062.4104.9167.91666.9167H17.416c.5063 0 .9167-.4105.9167-.9167V4.58335c0-.50626-.4104-.91666-.9167-.91666Z"/>
            <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12.8333 8.25H9.16667c-.50626 0-.91667.41041-.91667.91667v3.66663c0 .5063.41041.9167.91667.9167h3.66663c.5063 0 .9167-.4104.9167-.9167V9.16667c0-.50626-.4104-.91667-.9167-.91667Z"/>
          </svg>
          Placement print library
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonIcon from '@/components/Atoms/ButtonIcon.vue'
export default {
  components: {
    ButtonPrimary,
    ButtonIcon,
  },
  data: () => ({
    isShowCreateMenu: false,
  }),
}
</script>

<style lang="scss">
.download-block {
  position: relative;
  svg {
    width: 22px;
    height: 22px;
  }
  &__button {
    width: 20px;
    height: 20px;
    cursor: pointer;
    border-radius: 50%;
    &:hover {
      background-color: var(--Surface);
    }
  }
  &__items {
    border-radius: 8px;
    border: 1px solid var(--Dividers);
    position: absolute;
    background: var(--Basic-White);
    box-shadow: 0px 6px 8px 0px rgba(146, 158, 159, 0.10);
    z-index: 1;
    font-size: 16px;
    right: 0;
    top: calc(100% + 8px);
    width: 200px;
    &__item {
      border-radius: 8px;
      padding: 8px 16px;
      min-width: 100%;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 16px;
      font-size: 16px;
      font-family: 'DM Sans';
      font-weight: 400;
      &:hover {
        background: var(--Surface-Hover);
      }
    }
  }
}
</style>
